import { h, Component } from 'preact';
import React from 'react';
import PropTypes from 'prop-types';
import { stepComponents } from '../../../constants/Steps';
import Text from '../../Global/Text';
import { sendTrygTealium } from '../../../utilities/tracking';

class RecommendationContact extends Component {
  render() {
    const {
      userData,
      inputContact,
      dispatch,
      initialValues,
      title,
      desc,
      imgSrc,
      imgAlt,
      handleSubmit,
      onBlur,
      onChange,
      setValues,
      touched,
      values,
      setFieldValue,
      setFormValues,
      errors,
      translations,
      trackingStepNo,
      trackingCondition,
    } = this.props;

    const formParams = {
      handleSubmit,
      onChange,
      onBlur,
      touched,
      setValues,
      values,
      setFormValues,
      setFieldValue,
      dispatch,
      userData,
      errors,
    };
    const newTrackingStepNo = trackingStepNo;
    if (newTrackingStepNo && !this.state.isTrackingSent) {
      let send = true;
      if (trackingCondition) {
        Object.keys(trackingCondition)
          .forEach(key => {
            if (userData[key] !== trackingCondition[key]) {
              send = false;
            }
          });
      }
      if (send) {
        sendTrygTealium(newTrackingStepNo, userData, translations);
        this.state.isTrackingSent = true;
      }
    }

    return (
      <div className="section--container">
        <div className="recommendation__contact--container">
          <div className="recommendation__contact--left-section">
            <Text className="recommendation__contact--heading" component="h3" value={title} />
            <Text className="recommendation__contact--description" component="p" value={desc} />
            <div className="recommendation__contact--form-container">
            {inputContact && inputContact.map(list => {
              const inputParams = {
                ...list,
                ...formParams,
                initialValues: { ...initialValues },
              };
              const InputComponent = stepComponents[list.type];
              return (<InputComponent {...inputParams} />);
            })}
            </div>
          </div>
          <div className="recommendation__contact--right-section">
            <img src={imgSrc} alt={imgAlt} />
          </div>
        </div>
      </div>
    );
  }
}

export default RecommendationContact;

RecommendationContact.defaultProps = {
  inputContact: [],
  handleSubmit: null,
  onBlur: null,
  onChange: null,
  setFormValues: null,
  setValues: null,
  touched: null,
  values: null,
  errors: null,

};

RecommendationContact.propTypes = {
  userData: PropTypes.object.isRequired,
  title: PropTypes.object.isRequired,
  desc: PropTypes.object.isRequired,
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  inputContact: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  setFormValues: PropTypes.func,
  setValues: PropTypes.func,
  setFieldValue: PropTypes.func.isRequired,
  touched: PropTypes.object,
  values: PropTypes.object,
  initialValues: PropTypes.object.isRequired,
  errors: PropTypes.object,
  translations: PropTypes.string.isRequired,
  trackingStepNo: PropTypes.string.isRequired,
  trackingCondition: PropTypes.object.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Steps/General/RecommendationContact.jsx